import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { HomeV2Component } from './pages/home-v2/home-v2.component';
import { HomeV3Component } from './pages/home-v3/home-v3.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { EeatAuditComponent } from './shared/components/filter_eeat';
import { EducationV4Component } from './pages/education-v4/education-v4.component';
import { AICourseFinderComponent } from './pages/ai-course-finder/ai-course-finder.component';
import { UniversityAIIndexComponent } from './pages/university-ai-index/university-ai-index.component';
import { LandingComponent } from './pages/landing/landing.component';
import { TemplateAiAnalysisComponent } from './pages/template-ai-analysis/template-ai-analysis.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { AuthGuard, NoAuthGuard } from './guards/auth.guard';
import { AdminGuard, UniversityGuard, UniversityOnlyGuard } from './guards/role.guard';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { RoleManagementComponent } from './pages/role-management/role-management.component';
import { ProjectManagementComponent } from './pages/project-management/project-management.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { DiscoveryPagesManagementComponent } from './pages/discovery-pages-management/discovery-pages-management.component';
import { DiscoveryCitationsManagementComponent } from './pages/discovery-citations-management/discovery-citations-management.component';
import { TabNotesManagementComponent } from './pages/tab-notes-management/tab-notes-management.component';
import { GenericHomeComponent } from './pages/generic-home/generic-home.component';
import { EducationHomeComponent } from './pages/education-home/education-home.component';
import { FlowRouterComponent } from './shared/components/flow-router/flow-router.component';
import { EducationDashboardComponent } from './pages/education-dashboard/education-dashboard.component';
import { GenericDashboardComponent } from './pages/generic-dashboard/generic-dashboard.component';
import { ConditionalDashboardComponent } from './components/conditional-dashboard/conditional-dashboard.component';
import { AboutComponent } from './pages/about/about.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { CookiePolicyComponent } from './pages/cookie-policy/cookie-policy.component';
import { PricingComponent } from './pages/pricing/pricing.component';

export const routes: Routes = [
  // Public routes (no authentication required)
  {
    path: '',
    component: FlowRouterComponent,
    canActivate: [NoAuthGuard]
  },
  // Legal pages (accessible to everyone - authenticated and non-authenticated)
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'terms',
    component: TermsComponent
  },
  {
    path: 'privacy',
    component: PrivacyComponent
  },
  {
    path: 'cookie-policy',
    component: CookiePolicyComponent
  },
  {
    path: 'pricing',
    component: PricingComponent,
  },
  // {
  //   path: 'generic-home',
  //   component: GenericHomeComponent,
  //   canActivate: [NoAuthGuard]
  // },
  // {
  //   path: 'education-home',
  //   component: EducationHomeComponent,
  //   canActivate: [NoAuthGuard]
  // },
  {
    path: 'landing',
    component: LandingComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [NoAuthGuard]
  },

  // Protected routes (authentication required) - Use Layout Component
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // Conditional dashboard route
      {
        path: 'dashboard',
        component: ConditionalDashboardComponent
      },
      {
        path: 'education-dashboard',
        component: EducationDashboardComponent
      },
      {
        path: 'generic-dashboard',
        component: GenericDashboardComponent
      },
      // {
      //   path: 'education',
      //   component: EducationV4Component
      // },
      // {
      //   path: 'brand-analysis',
      //   component: HomeComponent
      // },
      // {
      //   path: 'v2',
      //   component: HomeV2Component
      // },
      // {
      //   path: 'v3',
      //   component: HomeV3Component
      // },
      // {
      //   path: 'v4/education',
      //   component: EducationV4Component
      // },
      // {
      //   path: 'eeat-audit',
      //   component: EeatAuditComponent
      // },
      // {
      //   path: 'ai-course-finder',
      //   component: AICourseFinderComponent
      // },
      // {
      //   path: 'university-ai-index',
      //   component: UniversityAIIndexComponent
      // },
      // {
      //   path: 'common-ai-analysis/:type/:app',
      //   component: TemplateAiAnalysisComponent
      // },
      // New cleaner education routes
      {
        path: 'common-ai-analysis/education/university',
        component: TemplateAiAnalysisComponent
      },
      {
        path: 'common-ai-analysis/education/student',
        component: TemplateAiAnalysisComponent
      },

      // New cleaner generic routes
      {
        path: 'common-ai-analysis/generic',
        component: TemplateAiAnalysisComponent
      },
      {
        path: 'common-ai-analysis/generic/:projectId',
        component: TemplateAiAnalysisComponent
      },

      // Admin-only management routes
      {
        path: 'admin/users',
        component: UserManagementComponent,
        canActivate: [AdminGuard]
      },
      {
        path: 'admin/roles',
        component: RoleManagementComponent,
        canActivate: [AdminGuard]
      },
      {
        path: 'admin/projects',
        component: ProjectManagementComponent,
        canActivate: [AdminGuard]
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'admin/settings',
        component: SettingsComponent,
        canActivate: [AdminGuard]
      },
      {
        path: 'admin/discovery-pages',
        component: DiscoveryPagesManagementComponent,
        canActivate: [AdminGuard]
      },
      {
        path: 'admin/discovery-citations',
        component: DiscoveryCitationsManagementComponent,
        canActivate: [AdminGuard]
      },
      {
        path: 'admin/tab-notes',
        component: TabNotesManagementComponent,
        canActivate: [AdminGuard]
      },

      // University-only project management
      {
        path: 'university/projects',
        component: ProjectManagementComponent,
        canActivate: [UniversityOnlyGuard]
      }
    ]
  },

  // Redirect authenticated users to conditional dashboard
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
